export interface AllAdvanceDetailRequest {
    productId: number;
    productName: string;
    quantity: number;
    price: number;
}

export function getRequestAdvancePaymente(invoice: any, currency: number, warehouseId: any): any {
    //AllAdvancePayment
    let dataAdvance = {}
    if (invoice.payment[0].paymentType === 1) {
        dataAdvance = {
            cashAcc: invoice.cash
        }
    } else if (invoice.payment[0].paymentType === 2) {
        dataAdvance = {
            bank: invoice.payment[0].bank,
            checkNumber: invoice.payment[0].checkNumber,
            clientName: invoice.payment[0].name,
            cashAcc: invoice.cash
        }
    } else if (invoice.payment[0].paymentType === 5) {
        dataAdvance = {
            bankAccount: invoice.payment[0].bankAccountId,
            docNumber: invoice.payment[0].transferNumber,
        }
    }
    const details = getAllAdvanceDetailRequest(invoice);

    return {
        typeNumber: invoice.payment[0].paymentType,
        
        amount: invoice.payment[0].amount,
        currency: currency,
        date: invoice.date,
        description: invoice.description,
        // currency: inv
        // exchangeRate
        vendor: invoice.clientId,
        warehouseId: warehouseId,
        details: details,
        ...dataAdvance
    };
}

export function getAllAdvanceDetailRequest(invoice: any): AllAdvanceDetailRequest[] {
    const data = invoice.detail as [];
    const request: AllAdvanceDetailRequest[] = data.map((item: any) => {
        return {
            productId: item.productId,
            productName: item.descriptionProduct,
            quantity: item.quantity,
            price: item.price
        }
    })
    return request;
    
}

